import { JsonObject } from 'json2typescript';
import { ChatMessageTextAddRequestInterface } from '../interfaces/chat-message-text-add-request.interface';

@JsonObject('ChatMessageTextAddRequestModel')
export class ChatMessageTextAddRequestModel
  implements ChatMessageTextAddRequestInterface
{
  TopicId?: string;
  Message?: string;
}
